export class DumbAdmin {
  contactId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  emailAddress: string;
  activeString: string;
  contactType: string;
  isActive: boolean;
  isActiveUser: boolean;
}
